import { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Util from 'lib/util';
import Http from 'services/http2';
import CompanyService from 'services/company2';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

function DialogProfitCenter(props) {
  const [data, setData] = useState({
    profitCenterCode: '',
    profitCenterName: '',
    receiveAreaCode: '',
    receiveAreaName: '',
    extendJson: ''
  });
  const [extendObj, setExtendObj] = useState({
    code: '',
    name: '',
    value: ''
  });
  let arrInit: any[] = [];
  let arrInit2: any[] = [];
  const [extendFields, setExtendFields] = useState(arrInit);
  const [extendValues, setExtendValues] = useState(arrInit2);

  const {
    currItem,
    profitCenterList,
    storehouseList,
    storehouseType,
    orgCompanyCode,
    open,
    onComplete,
    onClose
  } = props;

  //初始化
  useEffect(() => {
    function getDynaFields() {
      CompanyService.getExtendFields(currItem.customerCode).then(rs => {
        let arr: any[] = [];
        for (let key in rs) {
          if (Object.prototype.hasOwnProperty.call(rs, key)) {
            arr.push({
              id: key,
              text: rs[key]
            });
          }
        }
        if (arr.length > 0) {
          setExtendFields(arr);
        }
      });
    }
    //境外采购类型（purchaseType: 7）需传采购说明，示例：extendJson: "{"code":"extendN01","name":"计价单位1","value":"PCS"}"
    if (currItem?.purchaseType === 7) {
      getDynaFields();
    }
  }, [currItem]);

  //收货部门值改变
  function handleProfitCenterChange(event) {
    let code = event.target.value;
    let copy = Object.assign({}, data);
    let found = profitCenterList.find(item => item.id === code);
    if (found) {
      copy.profitCenterCode = found.id;
      copy.profitCenterName = found.profitCenterName;
    } else {
      copy.profitCenterCode = '';
      copy.profitCenterName = '';
    }
    setData(copy);
  }

  //收货仓库值改变
  function handleReceiveStoreChange(event) {
    let code = event.target.value;
    let copy = Object.assign({}, data);
    let found = storehouseList.find(item => item.id === code);
    if (found) {
      copy.receiveAreaCode = found.id;
      copy.receiveAreaName = found.text;
    } else {
      copy.receiveAreaCode = '';
      copy.receiveAreaName = '';
    }
    setData(copy);
  }

  //扩展字段改变
  function handleExtendFieldsChange(event) {
    let code = event.target.value;
    let copy = Object.assign({}, extendObj);
    let found = extendFields.find(item => item.id === code);
    if (found) {
      copy.code = found.id;
      copy.name = found.text;
      copy.value = '';
    } else {
      copy.code = '';
      copy.name = '';
      copy.value = '';
      setExtendValues([]);
    }
    setExtendObj(copy);
    queryGroupExtends(found);
  }

  //扩展字段值改变
  function handleExtendValuesChange(event) {
    let code = event.target.value;
    let copy = Object.assign({}, extendObj);
    let found = extendValues.find(item => item.id === code);
    if (found) {
      copy.value = found.text;
    } else {
      copy.value = '';
    }
    setExtendObj(copy);
  }

  //获取扩展字段可选值
  function queryGroupExtends(event) {
    let param = {};
    param[event.id] = event.text;
    let postbody = {
      companyCode: orgCompanyCode,
      customerXkUniqueCode: currItem.customerXkUniqueCode,
      extendFields: param,
      purchaseType: currItem.purchaseType,
      poXkNo: currItem.poXkNo,
      apiPath: '/customerPurchase/queryGroupExtends'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      let arr: any[] = [];
      setExtendValues([]);
      if (response.success && Array.isArray(response.data)) {
        response.data.forEach(val => {
          arr.push({ id: val, text: val });
        });
      }
      setExtendValues(arr);
    });
  }

  function ok() {
    let copy = Object.assign({}, data);
    if (!Util.isEmpty(extendObj.value)) {
      copy.extendJson = JSON.stringify(extendObj);
      setData(copy);
    }
    if (typeof onComplete === 'function') {
      onComplete(copy);
    }
    close();
  }

  function close() {
    if (typeof onClose === 'function') {
      onClose();
    }
  }

  return (
    <div>
      <Dialog
        fullWidth={true}
        open={open}
        onClose={close}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">新建送货</DialogTitle>
        <DialogContent style={{ paddingRight:'0' }}>
          {profitCenterList.length > 0 && (
            <FormControl>
              <InputLabel htmlFor="profit-center">收货部门</InputLabel>
              <Select
                style={{ minWidth: '250px' }}
                value={data.profitCenterCode}
                onChange={handleProfitCenterChange}
                input={<Input id="profit-center" />}
              >
                {profitCenterList.map((item, index) => (
                  <MenuItem key={index} value={item.id}>
                    <ListItemText primary={item.text} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {storehouseList.length > 0 && (
            <FormControl style={{ marginTop: '10px' }}>
              <InputLabel htmlFor="receive-area">
                {storehouseType === 1 ? '收货仓库' : '收货区'}
              </InputLabel>
              <Select
                style={{ width: '250px' }}
                value={data.receiveAreaCode}
                onChange={handleReceiveStoreChange}
                input={<Input id="receive-area" />}
              >
                {storehouseList.map((item, index) => (
                  <MenuItem key={index} value={item.id}>
                    <ListItemText primary={item.text} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {/* 采购说明 */}
          {extendFields.length > 0 && (
            <div style={{ marginTop: '10px' }}>
              <FormControl style={{ marginRight: '10px' }}>
                <InputLabel htmlFor="extend-field">采购说明属性</InputLabel>
                <Select
                  style={{ width: '120px' }}
                  value={extendObj.code}
                  onChange={handleExtendFieldsChange}
                  input={<Input id="extend-field" />}
                >
                  {extendFields.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      <ListItemText primary={item.text} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <InputLabel htmlFor="extend-value">采购说明值</InputLabel>
                <Select
                  style={{ width: '120px' }}
                  value={extendObj.value}
                  onChange={handleExtendValuesChange}
                  input={<Input id="extend-value" />}
                >
                  {extendValues.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      <ListItemText primary={item.text} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={close}
            variant="contained"
            className="m-flex-item u-btn u-btn_line"
          >
            取消
          </Button>
          <Button
            onClick={ok}
            variant="contained"
            color="primary"
            className="m-flex-item u-btn u-btn_primary"
          >
            确认
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DialogProfitCenter;
